module.exports = __webpack_public_path__ + "img/kistimldms_05.f5b3beb8.png";